import React from "react";
import { useNavigate } from "react-router-dom";
import { ANNOTATION_ICON } from "src/helpers";
import { Button } from "src/shadcn/components/ui";
import { OVERVIEW } from "../Finance/modules";
import { MAIN_ROUTES_CONST } from "src/navigations/modules";

interface Project {
    headerImage?: string;
    imageAttachments?: string[];
    projectName: string;
    projectSize: string;
    units?: string;
}

interface TopProjectsGridProps {
    top5Projects: Project[];
    projectType: string;
}

const TopProjectsGrid: React.FC<TopProjectsGridProps | any> = ({ top5Projects, projectType }) => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                background: "linear-gradient(to bottom, rgb(238, 237, 236), 50%, white 50%)",
            }}
        >
            <div className="space-y-8 pt-8 pb-8">
                <div className="px-4 md:px-16">
                    <div className="flex items-center space-x-2">
                        <img src={ANNOTATION_ICON} style={{ width: "20px", height: "20px" }} alt="ANNOTATION_ICON" />
                        <span className="font-bold text-3xl">Our Top 5 Projects</span>
                    </div>
                    <div className="px-[30px]">Highlighting the top projects that drive real change.</div>
                </div>

                <div className="px-16 mx-auto flex flex-col items-center space-y-8">
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mx-auto">
                        {top5Projects && Array.isArray(top5Projects) ? top5Projects.map(({ headerImage, imageAttachments, projectName, projectSize, units = "MW" }, index) => {
                            const img = headerImage || (imageAttachments?.length ? imageAttachments[0] : "");

                            return (
                                <div
                                    key={index}
                                    className="flex flex-col items-center space-y-2 bg-white rounded-xl overflow-hidden border border-primary"
                                >
                                    <img src={img} style={{ height: "220px", width: "100%" }} alt="Project Thumbnail" />
                                    <div className="flex flex-col items-center py-2">
                                        <span className="font-bold">
                                            {projectSize}
                                        </span>
                                        <span>{projectName}</span>
                                    </div>
                                </div>
                            );
                        }) : []}
                    </div>

                    <Button onClick={() => navigate("/" + MAIN_ROUTES_CONST.marketplace + "?projectCategoryType=" +projectType)} className="bg-primary text-white hover:bg-primary/90">
                        VIEW ALL PROJECTS
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default TopProjectsGrid;
